import { createRouter } from "@tanstack/react-router";

import { rootRoute } from "./routes/root.tsx";
import { homeRoute } from "./routes/home.tsx";
import { productsRoute } from "./routes/products.tsx";
import { shopRoute } from "./routes/shop.tsx";
import { inviteShareRoute } from "./routes/invite-share.tsx";
import { productDetailRoute } from "./routes/product-detail.tsx";
import { cartRoute } from "./routes/cart.tsx";
import { checkoutRoute } from "./routes/checkout.tsx";
import { ordersRoute } from "./routes/orders.tsx";
import { meRoute } from "./routes/me.tsx";
import { addressesRoute } from "./routes/addresses.tsx";
import { loginRoute } from "./routes/login.tsx";
import { inviteRoute } from "./routes/invite.tsx";
import { merchantRoute } from "./routes/merchant.tsx";
import { messagesRoute } from "./routes/messages.tsx";
import { myProductsRoute } from "./routes/my-products.tsx";
import { shipRoute } from "./routes/ship.tsx";
import { shopCategoriesRoute } from "./routes/shop-categories.tsx";
import { shopSettingsRoute } from "./routes/shop-settings.tsx";
import { withdrawRoute } from "./routes/withdraw.tsx";
import { supplierRoute } from "./routes/supplier.tsx";
import { adminRoute } from "./routes/admin.tsx";
import { caseDetailRoute } from "./routes/case-detail.tsx";
import { casesRoute } from "./routes/cases.tsx";
import { couponsRoute } from "./routes/coupons.tsx";
import { earningsRoute } from "./routes/earnings.tsx";
import { orderDetailRoute } from "./routes/order-detail.tsx";
import { securityRoute } from "./routes/security.tsx";
import { teamRoute } from "./routes/team.tsx";
import { sellerOrdersRoute } from "./routes/seller-orders.tsx";
import { myPricingRoute } from "./routes/my-pricing.tsx";
import { payRoute } from "./routes/pay.tsx";
import { restockRoute } from "./routes/restock.tsx";

const routeTree = rootRoute.addChildren([
  homeRoute,
  productsRoute,
  shopRoute,
  inviteShareRoute,
  productDetailRoute,
  cartRoute,
  checkoutRoute,
  ordersRoute,
  meRoute,
  addressesRoute,
  loginRoute,
  inviteRoute,
  merchantRoute,
  messagesRoute,
  myProductsRoute,
  shipRoute,
  shopCategoriesRoute,
  shopSettingsRoute,
  withdrawRoute,
  supplierRoute,
  adminRoute,
  restockRoute,
  myPricingRoute,
  couponsRoute,
  sellerOrdersRoute,
  orderDetailRoute,
  earningsRoute,
  teamRoute,
  securityRoute,
  casesRoute,
  caseDetailRoute,
  payRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
